import {
  GET_SINGLE_CUSTOMERS_DATA,
  GET_SINGLE_CUSTOMERS_DATA_SUCCESS,
  GET_SINGLE_CUSTOMERS_DATA_FAIL,
  ADD_SINGLE_CUSTOMER_SUCCESS,
  ADD_SINGLE_CUSTOMER_FAIL,
  UPDATE_SINGLE_CUSTOMER,
  UPDATE_SINGLE_CUSTOMER_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_FAIL,
  DELETE_SINGLE_CUSTOMER,
  DELETE_SINGLE_CUSTOMER_SUCCESS,
  DELETE_SINGLE_CUSTOMER_FAIL,
  GET_SINGLE_CUSTOMERS_LIST_DATA,
  GET_SINGLE_CUSTOMERS_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMERS_LIST_DATA_FAIL,
  CREATE_NEW_SINGLE_CUSTOMER,
  CREATE_SINGLE_CUSTOMER_SUCCESS,
  CREATE_SINGLE_CUSTOMER_FAIL,
  GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA,
  GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_FAIL,
  SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA,
  SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_FAIL,
  SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA,
  SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_FAIL,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_FAIL,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_FAIL,
  ADD_NEW_SINGLE_CUSTOMER_SITE_LOCATION,
  ADD_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
  ADD_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
  UPDATE_SINGLE_CUSTOMER_SITE_LOCATION,
  UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
  DELETE_SINGLE_CUSTOMER_SITE_LOCATION,
  DELETE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
  DELETE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
  GET_SINGLE_CUSTOMER_URL_LINK_DETAILS,
  GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_SUCCESS,
  GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_FAIL,
  CREATE_SINGLE_CUSTOMER_URL_LINK,
  CREATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
  CREATE_SINGLE_CUSTOMER_URL_LINK_FAIL,
  UPDATE_SINGLE_CUSTOMER_URL_LINK,
  UPDATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_URL_LINK_FAIL,
  DELETE_SINGLE_CUSTOMER_URL_LINK,
  DELETE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
  DELETE_SINGLE_CUSTOMER_URL_LINK_FAIL,
  GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA,
  GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_SUCCESS,
  GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_FAIL,
  GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA,
  GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_SUCCESS,
  GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_FAIL,
  GET_CUSTOMER_URL_LINK_STATUS_DETAILS,
  GET_CUSTOMER_URL_LINK_STATUS_DETAILS_SUCCESS,
  GET_CUSTOMER_URL_LINK_STATUS_DETAILS_FAIL,
  GET_CUSTOMER_URL_LINK_TYPE_DETAILS,
  GET_CUSTOMER_URL_LINK_TYPE_DETAILS_SUCCESS,
  GET_CUSTOMER_URL_LINK_TYPE_DETAILS_FAIL,
  CREATE_CUSTOMER_URL_LINK_STATUS,
  CREATE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
  CREATE_CUSTOMER_URL_LINK_STATUS_FAIL,
  CREATE_CUSTOMER_URL_LINK_TYPE,
  CREATE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
  CREATE_CUSTOMER_URL_LINK_TYPE_FAIL,
  UPDATE_CUSTOMER_URL_LINK_STATUS,
  UPDATE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
  UPDATE_CUSTOMER_URL_LINK_STATUS_FAIL,
  UPDATE_CUSTOMER_URL_LINK_TYPE,
  UPDATE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
  UPDATE_CUSTOMER_URL_LINK_TYPE_FAIL,
  DELETE_CUSTOMER_URL_LINK_STATUS,
  DELETE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
  DELETE_CUSTOMER_URL_LINK_STATUS_FAIL,
  DELETE_CUSTOMER_URL_LINK_TYPE,
  DELETE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
  DELETE_CUSTOMER_URL_LINK_TYPE_FAIL,
  GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA,
  GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_SUCCESS,
  GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_FAIL,
  GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA,
  GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_SUCCESS,
  GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_FAIL,
  GET_CUSTOMERS_BALANCE_LIST_ALL_DATA,
  GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_SUCCESS,
  GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_FAIL,
  CLEAR_CUSTOMER_TRANSACTIONS_LIST,
  CLEAR_CUSTOMER_TRANSACTIONS_LIST_SUCCESS,
  CLEAR_CUSTOMER_TRANSACTIONS_LIST_FAIL,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_SUCCESS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_FAIL,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_FAIL,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_SUCCESS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_FAIL,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
  GET_CUSTOMER_STATUS_LIST_DATA,
  GET_CUSTOMER_STATUS_LIST_DATA_SUCCESS,
  GET_CUSTOMER_STATUS_LIST_DATA_FAIL,
  GET_CUSTOMER_STATUS_DETAILS,
  GET_CUSTOMER_STATUS_DETAILS_SUCCESS,
  GET_CUSTOMER_STATUS_DETAILS_FAIL,
  CREATE_CUSTOMER_STATUS,
  CREATE_CUSTOMER_STATUS_SUCCESS,
  CREATE_CUSTOMER_STATUS_FAIL,
  UPDATE_CUSTOMER_STATUS,
  UPDATE_CUSTOMER_STATUS_SUCCESS,
  UPDATE_CUSTOMER_STATUS_FAIL,
  DELETE_CUSTOMER_STATUS,
  DELETE_CUSTOMER_STATUS_SUCCESS,
  DELETE_CUSTOMER_STATUS_FAIL,
  GET_CUSTOMER_TYPE_LIST_DATA,
  GET_CUSTOMER_TYPE_LIST_DATA_SUCCESS,
  GET_CUSTOMER_TYPE_LIST_DATA_FAIL,
  GET_CUSTOMER_TYPE_DETAILS,
  GET_CUSTOMER_TYPE_DETAILS_SUCCESS,
  GET_CUSTOMER_TYPE_DETAILS_FAIL,
  CREATE_CUSTOMER_TYPE,
  CREATE_CUSTOMER_TYPE_SUCCESS,
  CREATE_CUSTOMER_TYPE_FAIL,
  UPDATE_CUSTOMER_TYPE,
  UPDATE_CUSTOMER_TYPE_SUCCESS,
  UPDATE_CUSTOMER_TYPE_FAIL,
  DELETE_CUSTOMER_TYPE,
  DELETE_CUSTOMER_TYPE_SUCCESS,
  DELETE_CUSTOMER_TYPE_FAIL,
  EXPORT_CONTACTS,
  EXPORT_CONTACTS_SUCCESS,
  EXPORT_CONTACTS_FAIL,
  SEARCH_CUSTOMER,
  SEARCH_CUSTOMER_SUCCESS,
  SEARCH_CUSTOMER_FAIL,
  GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES,
  GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS,
  GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAIL,
  GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE,
  GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS,
  GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAIL,
  GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER,
  GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_SUCCESS,
  GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_FAIL,
  SEARCH_CUSTOMER_NOTE,
  SEARCH_CUSTOMER_NOTE_SUCCESS,
  SEARCH_CUSTOMER_NOTE_FAIL,
  CREATE_CUSTOMER_NOTE,
  CREATE_CUSTOMER_NOTE_SUCCESS,
  CREATE_CUSTOMER_NOTE_FAIL,
} from "./actionType";

const INIT_STATE = {
  customersData: [],
  singleCustomerData: [],
  deleteSingleCustomerDataSuccess: [],
  singleCustomerDataUpdateSuccess: [],
  customersDataList: [],
  customersDataListLoading: false,
  createSingleCustomerResponse: [],
  loading: false,
  error: "",
  singleCustomerActivitiesList: [],
  singleCustomerUrlLinkList: [],
  singleCustomerExternalIdsList: [],
  singleCustomerSiteLocationList: [],
  singleCustomerSiteLocationListLoading: false,
  singleCustomerSiteLocationData: [],
  singleCustomerSiteLocationDataLoading: false,
  createSingleCustomerSiteLocationResponse: [],
  updateSingleCustomerSiteLocationResponse: [],
  deleteSingleCustomerSiteLocationResponse: [],
  singleCustomerUrlLinkDetails: [],
  createSingleCustomerUrlLinkResponse: [],
  updateSingleCustomerUrlLinkResponse: [],
  deleteSingleCustomerUrlLinkResponse: [],
  customerUrlLinkStatusList: [],
  customerUrlLinkStatusDetails: [],
  createCustomerUrlLinkStatusResponse: [],
  updateCustomerUrlLinkStatusResponse: [],
  deleteCustomerUrlLinkStatusResponse: [],
  customerUrlLinkTypeList: [],
  customerUrlLinkTypeDetails: [],
  createCustomerUrlLinkTypeResponse: [],
  updateCustomerUrlLinkTypeResponse: [],
  deleteCustomerUrlLinkTypeResponse: [],
  customersDebitBalanceList: [],
  customersDebitBalanceListLoading: false,
  customersOverdueBalanceList: [],
  customersOverdueBalanceListLoading: false,
  customersBalanceListAll: [],
  customersBalanceListAllLoading: false,
  clearCustomerTransactionsList: [],
  clearCustomerTransactionsListSuccess: [],
  clearCustomerTransactionsListFail: [],

  singleCustomerExternalIdsDetails: [],
  singleCustomerExternalIdsDetailsSuccess: [],
  singleCustomerExternalIdsDetailsFail: [],

  createSingleCustomerExternalIdsResponse: [],
  createSingleCustomerExternalIdsResponseSuccess: [],
  createSingleCustomerExternalIdsResponseFail: [],

  updateSingleCustomerExternalIdsResponse: [],
  updateSingleCustomerExternalIdsResponseSuccess: [],
  updateSingleCustomerExternalIdsResponseFail: [],

  deleteSingleCustomerExternalIdsResponse: [],
  deleteSingleCustomerExternalIdsResponseSuccess: [],
  deleteSingleCustomerExternalIdsResponseFail: [],

  singleCustomerExternalIdsExternalIdentificationProviderList: [],
  singleCustomerExternalIdsExternalIdentificationProviderListSuccess: [],
  singleCustomerExternalIdsExternalIdentificationProviderListFail: [],

  singleCustomerExternalIdsExternalIdentificationProviderDetails: [],
  singleCustomerExternalIdsExternalIdentificationProviderDetailsSuccess: [],
  singleCustomerExternalIdsExternalIdentificationProviderDetailsFail: [],

  createSingleCustomerExternalIdsExternalIdentificationProviderResponse: [],
  createSingleCustomerExternalIdsExternalIdentificationProviderResponseSuccess:
    [],
  createSingleCustomerExternalIdsExternalIdentificationProviderResponseFail: [],

  updateSingleCustomerExternalIdsExternalIdentificationProviderResponse: [],
  updateSingleCustomerExternalIdsExternalIdentificationProviderResponseSuccess:
    [],
  updateSingleCustomerExternalIdsExternalIdentificationProviderResponseFail: [],

  deleteSingleCustomerExternalIdsExternalIdentificationProviderResponse: [],
  deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseSuccess:
    [],
  deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseFail: [],

  customerStatusList: [],
  loadingCustomerStatusList: false,
  customerStatusDetails: [],
  loadingCustomerStatusDetails: false,
  createCustomerStatusResponse: [],
  loadingCustomerStatusCreate: false,
  updateCustomerStatusResponse: [],
  loadingCustomerStatusUpdate: false,
  deleteCustomerStatusResponse: [],
  loadingCustomerStatusDelete: false,
  customerTypeList: [],
  loadingCustomerTypeList: false,
  customerTypeDetails: [],
  loadingCustomerTypeDetails: false,
  createCustomerTypeResponse: [],
  loadingCustomerTypeCreate: false,
  updateCustomerTypeResponse: [],
  loadingCustomerTypeUpdate: false,
  deleteCustomerTypeResponse: [],
  loadingCustomerTypeDelete: false,

  exportContacts: [],
  exportContactsLoading: false,
  exportContactsSuccess: [],
  exportContactsFail: [],

  searchCustomer: [],
  searchCustomerLoading: false,
  searchCustomerSuccess: [],

  //GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES
  customerBalanceHistoricalAvailableDates: [],
  customerBalanceHistoricalAvailableDatesLoading: false,
  customerBalanceHistoricalAvailableDatesFail: [],
  //GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE
  customerBalanceHistoricalSpecificDate: [],
  customerBalanceHistoricalSpecificDateLoading: false,
  customerBalanceHistoricalSpecificDateFail: [],
  //GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER
  customerBalanceHistoricalByCustomer: [],
  customerBalanceHistoricalByCustomerLoading: false,
  customerBalanceHistoricalByCustomerFail: [],

  searchCustomerNoteLoading: false,
  searchCustomerNoteSuccess: [],

  createCustomerNoteLoading: false,
  createCustomerNoteResponse: [],
};

const Customers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SINGLE_CUSTOMERS_DATA:
      return { ...state, loading: true, singleCustomerData: action.payload };
    case GET_SINGLE_CUSTOMERS_DATA_SUCCESS:
      return { ...state, loading: false, singleCustomerData: action.payload };
    case GET_SINGLE_CUSTOMERS_DATA_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADD_SINGLE_CUSTOMER_SUCCESS:
      return { ...state, loading: false, singleCustomerData: action.payload };
    case ADD_SINGLE_CUSTOMER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SINGLE_CUSTOMER:
      return { ...state, loading: true };
    case UPDATE_SINGLE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        singleCustomerDataUpdateSuccess: action.payload,
      };
    case UPDATE_SINGLE_CUSTOMER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SINGLE_CUSTOMER:
      return { ...state, loading: true };
    case DELETE_SINGLE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSingleCustomerDataSuccess: action.payload,
      };
    case DELETE_SINGLE_CUSTOMER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_SINGLE_CUSTOMERS_LIST_DATA:
      return { ...state, customersDataListLoading: true };
    case GET_SINGLE_CUSTOMERS_LIST_DATA_SUCCESS:
      return {
        ...state,
        customersDataListLoading: false,
        customersDataList: action.payload,
      };
    case GET_SINGLE_CUSTOMERS_LIST_DATA_FAIL:
      return {
        ...state,
        customersDataListLoading: false,
        error: action.payload,
      };

    case CREATE_NEW_SINGLE_CUSTOMER:
      return { ...state, loading: true };
    case CREATE_SINGLE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        createSingleCustomerResponse: action.payload,
      };
    case CREATE_SINGLE_CUSTOMER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA:
      return { ...state, loading: true };
    case GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        singleCustomerActivitiesList: action.payload,
      };
    case GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_FAIL:
      return { ...state, loading: false, error: action.payload };

    case SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA:
      return { ...state, loading: true };

    case SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        singleCustomerUrlLinkList: action.payload,
      };

    case SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_FAIL:
      return { ...state, loading: false, error: action.payload };

    case SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA:
      return { ...state, loading: true };

    case SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        singleCustomerExternalIdsList: action.payload,
      };

    case SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA:
      return { ...state, singleCustomerSiteLocationListLoading: true };
    case GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_SUCCESS:
      return {
        ...state,
        singleCustomerSiteLocationListLoading: false,
        singleCustomerSiteLocationList: action.payload,
      };
    case GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_FAIL:
      return {
        ...state,
        singleCustomerSiteLocationListLoading: false,
        error: action.payload,
      };

    case GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA:
      return { ...state, singleCustomerSiteLocationDataLoading: true };
    case GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_SUCCESS:
      return {
        ...state,
        singleCustomerSiteLocationDataLoading: false,
        singleCustomerSiteLocationData: action.payload,
      };
    case GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_FAIL:
      return {
        ...state,
        singleCustomerSiteLocationDataLoading: false,
        error: action.payload,
      };

    case ADD_NEW_SINGLE_CUSTOMER_SITE_LOCATION:
      return { ...state, loading: true };
    case ADD_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        createSingleCustomerSiteLocationResponse: action.payload,
      };
    case ADD_SINGLE_CUSTOMER_SITE_LOCATION_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SINGLE_CUSTOMER_SITE_LOCATION:
      return { ...state, loading: true };
    case UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSingleCustomerSiteLocationResponse: action.payload,
      };
    case UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SINGLE_CUSTOMER_SITE_LOCATION:
      return { ...state, loading: true };
    case DELETE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSingleCustomerSiteLocationResponse: action.payload,
      };

    case DELETE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_SINGLE_CUSTOMER_URL_LINK_DETAILS:
      return { ...state, loading: true };
    case GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        singleCustomerUrlLinkDetails: action.payload,
      };
    case GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CREATE_SINGLE_CUSTOMER_URL_LINK:
      return { ...state, loading: true };
    case CREATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        createSingleCustomerUrlLinkResponse: action.payload,
      };
    case CREATE_SINGLE_CUSTOMER_URL_LINK_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SINGLE_CUSTOMER_URL_LINK:
      return { ...state, loading: true };
    case UPDATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSingleCustomerUrlLinkResponse: action.payload,
      };
    case UPDATE_SINGLE_CUSTOMER_URL_LINK_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SINGLE_CUSTOMER_URL_LINK:
      return { ...state, loading: true };
    case DELETE_SINGLE_CUSTOMER_URL_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSingleCustomerUrlLinkResponse: action.payload,
      };
    case DELETE_SINGLE_CUSTOMER_URL_LINK_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA:
      return { ...state, loading: true };
    case GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        customerUrlLinkStatusList: action.payload,
      };
    case GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_CUSTOMER_URL_LINK_STATUS_DETAILS:
      return { ...state, loading: true };
    case GET_CUSTOMER_URL_LINK_STATUS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        customerUrlLinkStatusDetails: action.payload,
      };
    case GET_CUSTOMER_URL_LINK_STATUS_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CREATE_CUSTOMER_URL_LINK_STATUS:
      return { ...state, loading: true };
    case CREATE_CUSTOMER_URL_LINK_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        createCustomerUrlLinkStatusResponse: action.payload,
      };
    case CREATE_CUSTOMER_URL_LINK_STATUS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_CUSTOMER_URL_LINK_STATUS:
      return { ...state, loading: true };
    case UPDATE_CUSTOMER_URL_LINK_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateCustomerUrlLinkStatusResponse: action.payload,
      };
    case UPDATE_CUSTOMER_URL_LINK_STATUS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_CUSTOMER_URL_LINK_STATUS:
      return { ...state, loading: true };
    case DELETE_CUSTOMER_URL_LINK_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteCustomerUrlLinkStatusResponse: action.payload,
      };
    case DELETE_CUSTOMER_URL_LINK_STATUS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA:
      return { ...state, loading: true };
    case GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        customerUrlLinkTypeList: action.payload,
      };
    case GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_CUSTOMER_URL_LINK_TYPE_DETAILS:
      return { ...state, loading: true };
    case GET_CUSTOMER_URL_LINK_TYPE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        customerUrlLinkTypeDetails: action.payload,
      };
    case GET_CUSTOMER_URL_LINK_TYPE_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CREATE_CUSTOMER_URL_LINK_TYPE:
      return { ...state, loading: true };
    case CREATE_CUSTOMER_URL_LINK_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        createCustomerUrlLinkTypeResponse: action.payload,
      };
    case CREATE_CUSTOMER_URL_LINK_TYPE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_CUSTOMER_URL_LINK_TYPE:
      return { ...state, loading: true };
    case UPDATE_CUSTOMER_URL_LINK_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        updateCustomerUrlLinkTypeResponse: action.payload,
      };
    case UPDATE_CUSTOMER_URL_LINK_TYPE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_CUSTOMER_URL_LINK_TYPE:
      return { ...state, loading: true };
    case DELETE_CUSTOMER_URL_LINK_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteCustomerUrlLinkTypeResponse: action.payload,
      };
    case DELETE_CUSTOMER_URL_LINK_TYPE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA:
      return { ...state, customersDebitBalanceListLoading: true };

    case GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_SUCCESS:
      return {
        ...state,
        customersDebitBalanceListLoading: false,
        customersDebitBalanceList: action.payload,
      };

    case GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_FAIL:
      return {
        ...state,
        customersDebitBalanceListLoading: false,
        error: action.payload,
      };

    case GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA:
      return { ...state, customersOverdueBalanceListLoading: true };

    case GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_SUCCESS:
      return {
        ...state,
        customersOverdueBalanceListLoading: false,
        customersOverdueBalanceList: action.payload,
      };

    case GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_FAIL:
      return {
        ...state,
        customersOverdueBalanceListLoading: false,
        error: action.payload,
      };

    case GET_CUSTOMERS_BALANCE_LIST_ALL_DATA:
      return { ...state, customersBalanceListAllLoading: true };

    case GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_SUCCESS:
      return {
        ...state,
        customersBalanceListAllLoading: false,
        customersBalanceListAll: action.payload,
      };

    case GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_FAIL:
      return {
        ...state,
        customersBalanceListAllLoading: false,
        error: action.payload,
      };

    case CLEAR_CUSTOMER_TRANSACTIONS_LIST:
      return { ...state, loading: true };
    case CLEAR_CUSTOMER_TRANSACTIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        clearCustomerTransactionsList: action.payload,
      };
    case CLEAR_CUSTOMER_TRANSACTIONS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS:
      return { ...state, loading: true };
    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        singleCustomerExternalIdsDetails: action.payload,
      };
    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS:
      return { ...state, loading: true };
    case CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS:
      return {
        ...state,
        loading: false,
        createSingleCustomerExternalIdsResponse: action.payload,
      };
    case CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS:
      return { ...state, loading: true };
    case UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSingleCustomerExternalIdsResponse: action.payload,
      };
    case UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS:
      return { ...state, loading: true };
    case DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSingleCustomerExternalIdsResponse: action.payload,
      };
    case DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA:
      return { ...state, loading: true };
    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        singleCustomerExternalIdsExternalIdentificationProviderList:
          action.payload,
      };
    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS:
      return { ...state, loading: true };
    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        singleCustomerExternalIdsExternalIdentificationProviderDetails:
          action.payload,
      };
    case GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER:
      return { ...state, loading: true };
    case CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS:
      return {
        ...state,
        loading: false,
        createSingleCustomerExternalIdsExternalIdentificationProviderResponse:
          action.payload,
      };
    case CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER:
      return { ...state, loading: true };
    case UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSingleCustomerExternalIdsExternalIdentificationProviderResponse:
          action.payload,
      };
    case UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER:
      return { ...state, loading: true };
    case DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSingleCustomerExternalIdsExternalIdentificationProviderResponse:
          action.payload,
      };
    case DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_CUSTOMER_STATUS_LIST_DATA:
      return { ...state, loadingCustomerStatusList: true };
    case GET_CUSTOMER_STATUS_LIST_DATA_SUCCESS:
      return {
        ...state,
        loadingCustomerStatusList: false,
        customerStatusList: action.payload,
      };
    case GET_CUSTOMER_STATUS_LIST_DATA_FAIL:
      return {
        ...state,
        loadingCustomerStatusList: false,
        error: action.payload,
      };

    case GET_CUSTOMER_STATUS_DETAILS:
      return { ...state, loadingCustomerStatusDetails: true };
    case GET_CUSTOMER_STATUS_DETAILS_SUCCESS:
      return {
        ...state,
        loadingCustomerStatusDetails: false,
        customerStatusDetails: action.payload,
      };
    case GET_CUSTOMER_STATUS_DETAILS_FAIL:
      return {
        ...state,
        loadingCustomerStatusDetails: false,
        error: action.payload,
      };

    case CREATE_CUSTOMER_STATUS:
      return { ...state, loadingCustomerStatusCreate: true };
    case CREATE_CUSTOMER_STATUS_SUCCESS:
      return {
        ...state,
        loadingCustomerStatusCreate: false,
        createCustomerStatusResponse: action.payload,
      };
    case CREATE_CUSTOMER_STATUS_FAIL:
      return {
        ...state,
        loadingCustomerStatusCreate: false,
        error: action.payload,
      };

    case UPDATE_CUSTOMER_STATUS:
      return { ...state, loadingCustomerStatusUpdate: true };
    case UPDATE_CUSTOMER_STATUS_SUCCESS:
      return {
        ...state,
        loadingCustomerStatusUpdate: false,
        updateCustomerStatusResponse: action.payload,
      };
    case UPDATE_CUSTOMER_STATUS_FAIL:
      return {
        ...state,
        loadingCustomerStatusUpdate: false,
        error: action.payload,
      };

    case DELETE_CUSTOMER_STATUS:
      return { ...state, loadingCustomerStatusDelete: true };
    case DELETE_CUSTOMER_STATUS_SUCCESS:
      return {
        ...state,
        loadingCustomerStatusDelete: false,
        deleteCustomerStatusResponse: action.payload,
      };
    case DELETE_CUSTOMER_STATUS_FAIL:
      return {
        ...state,
        loadingCustomerStatusDelete: false,
        error: action.payload,
      };

    case GET_CUSTOMER_TYPE_LIST_DATA:
      return { ...state, loadingCustomerTypeList: true };
    case GET_CUSTOMER_TYPE_LIST_DATA_SUCCESS:
      return {
        ...state,
        loadingCustomerTypeList: false,
        customerTypeList: action.payload,
      };
    case GET_CUSTOMER_TYPE_LIST_DATA_FAIL:
      return {
        ...state,
        loadingCustomerTypeList: false,
        error: action.payload,
      };

    case GET_CUSTOMER_TYPE_DETAILS:
      return { ...state, loadingCustomerTypeDetails: true };
    case GET_CUSTOMER_TYPE_DETAILS_SUCCESS:
      return {
        ...state,
        loadingCustomerTypeDetails: false,
        customerTypeDetails: action.payload,
      };
    case GET_CUSTOMER_TYPE_DETAILS_FAIL:
      return {
        ...state,
        loadingCustomerTypeDetails: false,
        error: action.payload,
      };

    case CREATE_CUSTOMER_TYPE:
      return { ...state, loadingCustomerTypeCreate: true };
    case CREATE_CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        loadingCustomerTypeCreate: false,
        createCustomerTypeResponse: action.payload,
      };
    case CREATE_CUSTOMER_TYPE_FAIL:
      return {
        ...state,
        loadingCustomerTypeCreate: false,
        error: action.payload,
      };

    case UPDATE_CUSTOMER_TYPE:
      return { ...state, loadingCustomerTypeUpdate: true };
    case UPDATE_CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        loadingCustomerTypeUpdate: false,
        updateCustomerTypeResponse: action.payload,
      };
    case UPDATE_CUSTOMER_TYPE_FAIL:
      return {
        ...state,
        loadingCustomerTypeUpdate: false,
        error: action.payload,
      };

    case DELETE_CUSTOMER_TYPE:
      return { ...state, loadingCustomerTypeDelete: true };
    case DELETE_CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        loadingCustomerTypeDelete: false,
        deleteCustomerTypeResponse: action.payload,
      };
    case DELETE_CUSTOMER_TYPE_FAIL:
      return {
        ...state,
        loadingCustomerTypeDelete: false,
        error: action.payload,
      };

    case EXPORT_CONTACTS:
      return { ...state, exportContactsLoading: true };
    case EXPORT_CONTACTS_SUCCESS:
      return {
        ...state,
        exportContactsLoading: false,
        exportContactsSuccess: action.payload,
      };
    case EXPORT_CONTACTS_FAIL:
      return {
        ...state,
        exportContactsLoading: false,
        exportContactsFail: action.payload,
      };
    case SEARCH_CUSTOMER:
      return { ...state, searchCustomerLoading: true };
    case SEARCH_CUSTOMER_SUCCESS:
      return {
        ...state,
        searchCustomerLoading: false,
        searchCustomerSuccess: action.payload,
      };
    case SEARCH_CUSTOMER_FAIL:
      return {
        ...state,
        searchCustomerLoading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES:
      return { ...state, customerBalanceHistoricalAvailableDatesLoading: true };
    case GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS:
      return {
        ...state,
        customerBalanceHistoricalAvailableDatesLoading: false,
        customerBalanceHistoricalAvailableDates: action.payload,
      };
    case GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAIL:
      return {
        ...state,
        customerBalanceHistoricalAvailableDatesLoading: false,
        customerBalanceHistoricalAvailableDatesFail: action.payload,
      };
    case GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE:
      return { ...state, customerBalanceHistoricalSpecificDateLoading: true };
    case GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS:
      return {
        ...state,
        customerBalanceHistoricalSpecificDateLoading: false,
        customerBalanceHistoricalSpecificDate: action.payload,
      };
    case GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAIL:
      return {
        ...state,
        customerBalanceHistoricalSpecificDateLoading: false,
        customerBalanceHistoricalSpecificDateFail: action.payload,
      };

    case GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER:
      return { ...state, customerBalanceHistoricalByCustomerLoading: true };
    case GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_SUCCESS:
      return {
        ...state,
        customerBalanceHistoricalByCustomerLoading: false,
        customerBalanceHistoricalByCustomer: action.payload,
      };
    case GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_FAIL:
      return {
        ...state,
        customerBalanceHistoricalByCustomerLoading: false,
        customerBalanceHistoricalByCustomerFail: action.payload,
      };

    case SEARCH_CUSTOMER_NOTE:
      return { ...state, searchCustomerNoteLoading: true };
    case SEARCH_CUSTOMER_NOTE_SUCCESS:
      return {
        ...state,
        searchCustomerNoteLoading: false,
        searchCustomerNoteSuccess: action.payload,
      };
    case SEARCH_CUSTOMER_NOTE_FAIL:
      return {
        ...state,
        searchCustomerNoteLoading: false,
        error: action.payload,
      };
    case CREATE_CUSTOMER_NOTE:
      return { ...state, createCustomerNoteLoading: true };
    case CREATE_CUSTOMER_NOTE_SUCCESS:
      return {
        ...state,
        createCustomerNoteLoading: false,
        createCustomerNoteResponse: action.payload,
      };
    case CREATE_CUSTOMER_NOTE_FAIL:
      return {
        ...state,
        createCustomerNoteLoading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export default Customers;
